export default "__VITE_ASSET__BxvLj2er__"